angular
    .module('tradersyard')
    .factory('user-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        filter.set(filter.get());
                    },
                    is: function (name) {
                        return filter.tab() === name && filter.visibility(name);
                    },
                    /**
                     * Return true if the second-line have one or more tab with access to view.
                     *
                     * @returns {*}
                     */
                    secondLineHasItems: function () {
                        return (
                            this.visibility('webinar') ||
                            this.visibility('group') ||
                            this.visibility('event') ||
                            this.visibility('analytic')
                        );
                    },
                    /**
                     * Return true if current user have access to view that page.
                     *
                     * @param name
                     * @returns {*}
                     */
                    visibility: function (name) {
                        const isVisible = $flex?.data?.node?.privacy_settings?.[`${name}.privacy`];
                        return isVisible ?? true;
                    },
                    get: function () {
                        hash = $flex.$hash.get();

                        hash = hash.split('.');

                        hash[filter.level] =
                            [
                                'timeline',
                                'webinar',
                                'group',
                                'event',
                                'information',
                                'friend',
                                'request',
                                'analytic',
                                'document',
                                'video',
                                'photo',
                                'trade_sharing',
                                'analysis_sharing',
                            ].indexOf(hash[filter.level]) !== -1
                                ? hash[filter.level]
                                : 'timeline';

                        hash = hash.join('.');

                        return hash;
                    },
                    set: function (name) {
                        tab = name;

                        if (!filter.visibility(name)) {
                            return;
                        }

                        if (filter.on.change) filter.on.change();

                        var _name = name.split('.');

                        $flex.$touch.make(_name[filter.level]);
                        $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab !== undefined ? tab.split('.')[filter.level] : tab;
                    },
                    on: {
                        change: undefined,
                    },
                    level: 0,
                };

            return filter;
        },
    ])
    .controller('user-read-ctrl', [
        '$rootScope',
        '$scope',
        'graph-user-factory',
        'graph-request-factory',
        '$flex',
        'user-read-filter',
        '$flex.scroll',
        '$timeout',
        'WebSocket',
        '$q',
        'updatesService',
        'AuthService',
        'RequestManagerFactory',
        function (
            $rootScope,
            $scope,
            userFactory,
            $request,
            $flex,
            $filter,
            $scroll,
            $timeout,
            $socket,
            $q,
            $updates,
            Auth,
            RequestManagerFactory
        ) {
            $scope.participantRole = undefined;
            $scope.showAllMenu = false;
            $scope.filter = $filter;
            $scope.node = {};
            $scope.friends = [];
            $scope.documents = [];
            $scope.posts = [];
            $scope.photos = [];
            $scope.videos = [];
            $scope.video = {};
            $scope.information = {};
            $scope.friends_count = 0;
            $scope.params = {
                timeline: {
                    page: 0,
                },
                documents: {
                    page: 0,
                },
                friends: {
                    page: 0,
                    let: 0,
                    limit: 25,
                },
                photos: {
                    page: 0,
                },
                videos: {
                    page: 0,
                },
            };

            $scope.setParticipantRole = function (role) {
                $scope.participantRole = !!role ? role : undefined;
                setTimeout(function () {
                    $rootScope.$broadcast('participant:role', role);
                });
            };

            function userCanAction(node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (node.owner.id === $rootScope.me.id) {
                    return true;
                }

                return false;
            }

            angular.extend($scope, $flex.data);

            $scope.userCanEditComment = userCanAction;
            $scope.userCanDeleteMessage = userCanAction;

            $scope.Request = RequestManagerFactory.Init($rootScope.me ? $rootScope.me.id : null, 'user', $scope);

            $scope.Request.Count = $scope.requests;

            var canceler = $q.defer();

            angular.extend($scope, $flex.data);

            var commentIdHistory = [];
            var eventQueue = [];

            function queueCircle() {
                while (eventQueue.length > 0) {
                    setTimeout(eventQueue.shift(), 100);
                }

                setTimeout(queueCircle, 100);
            }

            queueCircle();

            $socket.on('comment:create', function (data) {
                eventQueue.push(function () {
                    var aggregatedKey = 'c:' + data.node.id;

                    if (commentIdHistory.indexOf(aggregatedKey) < 0) {
                        commentIdHistory.push(aggregatedKey);

                        if (data.place.name === 'post') {
                            $scope.posts.forEach(function (node) {
                                if (parseInt(node.id) === parseInt(data.place.id)) {
                                    ++node.comments;
                                    if (!$scope.$$phase) {
                                        $scope.$digest();
                                    }
                                }
                            });
                        }
                    }
                });
            });

            $socket.on('comment:delete', function (data) {
                eventQueue.push(function () {
                    var aggregatedKey = 'd:' + data.node.id;

                    if (commentIdHistory.indexOf(aggregatedKey) < 0) {
                        commentIdHistory.push(aggregatedKey);

                        if (data.place.name === 'post') {
                            $scope.posts.forEach(function (node) {
                                if (parseInt(node.id) === parseInt(data.place.id)) {
                                    --node.comments;
                                    if (!$scope.$$phase) {
                                        $scope.$digest();
                                    }
                                }
                            });
                        }
                    }
                });
            });

            $scope.load = {
                timeline: function (next) {
                    ++$scope.params.timeline.page;
                    userFactory
                        .posts($scope.node.id)
                        .query({ params: $scope.params.timeline })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.posts = $scope.posts.concat(response.data.data);

                                $socket.emit(
                                    'join:post',
                                    response.data.data.map(function (item) {
                                        return item.id;
                                    })
                                );

                                if (next) next();
                            }
                        });
                },
                friends: function (next) {
                    ++$scope.params.friends.page;
                    userFactory
                        .friends($scope.node.id)
                        .query({ params: $scope.params.friends })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.friends = $scope.friends.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                requests: function (next) {
                    $scope.Request.Query(next);
                },
                documents: function (next) {
                    canceler.resolve();
                    canceler = $q.defer();

                    ++$scope.params.documents.page;
                    userFactory
                        .documents($scope.node.id)
                        .query({ params: $scope.params.documents, timeout: canceler.promise })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.documents = $scope.documents.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                loadDocuments: function loadDocuments(pagination) {
                    // cancel previous request
                    canceler.resolve();
                    canceler = $q.defer();

                    $scope.params.documents.page = pagination.page;

                    return userFactory
                        .documents($scope.node.id)
                        .query({
                            // pass pagination and filters
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            $scope.documents = $scope.documents.concat(response.data.data);
                            // return pagination info for <load-more-button> component
                            return {
                                totalItems: response.data.total,
                                totalPages: response.data.pages,
                            };
                        });
                },
                information: function () {
                    userFactory.info($scope.node.id).then(function (response) {
                        if (response.data.state === 0) {
                            $scope.information = response.data.data;
                        }
                    });
                },
                photos: function (next) {
                    ++$scope.params.photos.page;
                    userFactory
                        .photos($scope.node.id)
                        .query({ params: $scope.params.photos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.photos = $scope.photos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                videos: function (next) {
                    ++$scope.params.videos.page;
                    userFactory
                        .videos($scope.node.id)
                        .query({ params: $scope.params.videos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.videos = $scope.videos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };

            $scope.upload = {
                headerImage: uploadHeaderImage,
                error: function (error) {
                    $rootScope.$broadcast('graph-modal-show', {
                        title: 'Error',
                        content: error,
                    });
                },
                photo: function (node) {
                    if ($scope.form.photo.$valid === true) {
                        userFactory
                            .photos(node.id)
                            .upload({
                                name: $scope.photo.name,
                                photo: $scope.photo.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $scope.photos.unshift(response.data.data);

                                    // if ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') {
                                    //     $rootScope.$apply();
                                    // }
                                } else {
                                    $rootScope.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                video: function (node) {
                    // console.log('upload');
                    if ($scope.form.video.$valid === true) {
                        var fd = new FormData();
                        fd.append('video', $scope.video.file);
                        fd.append('name', $scope.video.name);

                        userFactory
                            .videos(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $scope.videos.unshift(response.data.data);
                                } else {
                                    $rootScope.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.video ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                picture: function (node) {
                    if ($scope.form.picture.$valid === true) {
                        userFactory
                            .picture(node.id)
                            .upload({
                                name: $scope.picture.name,
                                photo: $scope.picture.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    userFactory
                                        .picture(node.id)
                                        .attach(response.data.data.id, {})
                                        .then(function (response) {
                                            if (response.data.state === 0) {
                                                node.picture = response.data.data;
                                            }
                                        });
                                } else {
                                    $rootScope.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                cover: function (node) {
                    if ($scope.form.cover.$valid === true) {
                        userFactory
                            .cover(node.id)
                            .upload({
                                name: $scope.cover.name,
                                photo: $scope.cover.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    userFactory
                                        .cover(node.id)
                                        .attach(response.data.data.id, {})
                                        .then(function (response) {
                                            if (response.data.state === 0) {
                                                node.cover = response.data.data;
                                            }
                                        });
                                } else {
                                    $rootScope.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                document: function (node) {
                    if ($scope.form.document.$valid === true) {
                        var fd = new FormData();
                        fd.append('document', $scope.document.file);
                        fd.append('name', $scope.document.name);

                        userFactory
                            .documents(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $scope.documents.unshift(response.data.data);
                                } else {
                                    $rootScope.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.document ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
            };

            function uploadAndAttachPhoto(userEntry, file, attachFunc) {
                if (!userEntry.id) {
                    return $q.reject('Passed User object does not have an id prop');
                }

                if (!file) {
                    return $q.reject('File object not provided');
                }

                return userFactory
                    .uploadUserPhoto(userEntry.id, {
                        name: file.name,
                        data64: file.base,
                    })
                    .then(attachFunc)
                    .catch(function () {
                        $rootScope.$broadcast('graph-modal-show', {
                            title: 'Error',
                            content: 'The file is too large or the format is incorrect.',
                        });
                    });
            }

            function uploadHeaderImage(userEntry, file) {
                uploadAndAttachPhoto(userEntry, file, function (photoObj) {
                    return userFactory.attachHeaderImage(userEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    userEntry.cover = photoEntry;
                });
            }

            $scope.delete = {
                photo: function (node, index) {
                    userFactory
                        .photos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.photos.splice(index, 1);
                            }
                        });
                },
                video: function (node, index) {
                    userFactory
                        .videos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.videos.splice(index, 1);
                            }
                        });
                },
                document: function (node, index) {
                    userFactory
                        .documents($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.documents.splice(index, 1);
                            }
                        });
                },
            };

            $scope.filter.on.change = function () {
                $scroll.switch($scope.filter.tab());
                $timeout(function () {
                    $scope.$broadcast($scope.filter.tab() + '-query-update');
                }, 10);
            };

            $scope.follow = function (userId) {
                userFactory.follow(userId).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.node.following = true;
                    }
                });
            };

            $scope.unfollow = function (userId) {
                userFactory.unfollow(userId).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.node.following = false;
                    }
                });
            };

            $scope.$on('touch:timeline', function () {
                $scope.load.timeline();
            });

            $scope.$on('touch:friend', function () {
                $scope.load.friends();
            });

            $scope.$on('touch:video', function () {
                $scope.load.videos();
            });

            $scope.$on('touch:photo', function () {
                $scope.load.photos();
            });

            $scope.$on('touch:request', function () {
                $scope.load.requests();
            });

            $socket.on('me:friend:unfriend', function (data) {
                --$scope.friends_count;
                --$scope.params.friends.let;

                $scope.friends.forEach(function (friend, i) {
                    if (friend.id === data.node.id) {
                        $scope.friends.splice(i, 1);
                    }
                });

                if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                    $rootScope.$apply();
                }
            });

            // todo: this code was broken,
            //       I wasn't sure what was it supposed to do,
            //       Commenting it out doesnt seem to break anything
            // $socket.on('request:create', function (data) {
            //     if (data.place.name === instance.Entry && parseInt(data.place.id) === parseInt(instance.Id)) {
            //         var index = instance.Guid.indexOf(data.guid);
            //
            //         if (index === -1) {
            //             instance.Add(data.node);
            //             instance.Digest();
            //         } else {
            //             instance.Guid.splice(index, 1);
            //             if (instance.Count !== undefined) {
            //                 ++instance.Count;
            //             }
            //         }
            //     }
            // });

            $socket.on('me:request:create', function (data) {
                var suggestionId = data.place.id;
                console.log(suggestionId);
                $scope.suggestions.forEach(function (suggestion, index) {
                    if (suggestion.id === suggestionId) {
                        $scope.suggestions.splice(index, 1);
                        if (!$scope.$$phase) $scope.$digest();
                    }
                });
            });

            $socket.on('me:friend:friend', function (data) {
                ++$scope.friends_count;
                ++$scope.params.friends.let;
                $scope.friends.unshift(data.node);
                if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                    $rootScope.$apply();
                }
            });

            $scope.$on('touch:document', function () {
                $scope.documentsPagination = new Paginate(function (params) {
                    return userFactory
                        .documents($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            return {
                                items: response.data.data,
                                totalPages: response.data.pages,
                            };
                        });
                });

                /**
                 * @param {PaginateData} paginationData
                 */
                $scope.documentsPagination.onPageLoad = function (paginationData) {
                    $scope.documents = [].concat($scope.documents, paginationData.items);
                };

                $scope.documentsPagination.onReset = function () {
                    $scope.documents = [];
                };

                $scope.$on('document-filter-update', function ($e, queryFilters) {
                    $scope.documentsPagination.reset({ queryFilters: queryFilters });
                });
            });

            $scope.$on('touch:information', function () {
                $scope.load.information();
            });

            $socket.on('friend:friend', function (data) {
                if (parseInt(data.place.id) === parseInt($scope.node.id)) {
                    ++$scope.friends_count;
                    ++$scope.params.friends.let;
                    $scope.friends.unshift(data.user);
                    if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                        $rootScope.$apply();
                    }
                }
            });

            $socket.on('friend:unfriend', function (data) {
                if (parseInt(data.place.id) === parseInt($scope.node.id)) {
                    --$scope.friends_count;
                    --$scope.params.friends.let;

                    $scope.friends.forEach(function (friend, i) {
                        if (friend.id === data.user.id) {
                            $scope.friends.splice(i, 1);
                        }
                    });

                    if (data.user.id === $rootScope.me.id) {
                        $scope.node.im_friend = false;
                    }

                    if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                        $rootScope.$apply();
                    }
                }
            });

            if ($rootScope.authorized) {
                $socket.on('request:create', function (data) {
                    if (
                        parseInt(data.place.id) === parseInt($scope.node.id) &&
                        parseInt(data.node.owner.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.is_requested = true;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }

                    if (
                        parseInt(data.node.owner.id) === parseInt($scope.node.id) &&
                        parseInt(data.place.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.request_pending = true;
                        $scope.node.request_id = data.node.id;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }
                });

                $socket.on('request:accept', function (data) {
                    if (
                        parseInt(data.place.id) === parseInt($scope.node.id) &&
                        parseInt(data.node.owner.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.is_requested = false;
                        $scope.node.im_friend = true;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }

                    if (
                        parseInt(data.node.owner.id) === parseInt($scope.node.id) &&
                        parseInt(data.place.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.request_pending = false;
                        $scope.node.im_friend = true;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }
                });

                $socket.on('request:reject', function (data) {
                    if (
                        parseInt(data.place.id) === parseInt($scope.node.id) &&
                        parseInt(data.node.owner.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.is_requested = false;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }

                    if (
                        parseInt(data.node.owner.id) === parseInt($scope.node.id) &&
                        parseInt(data.place.id) === parseInt($rootScope.me.id)
                    ) {
                        $scope.node.request_pending = false;

                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }
                });

                if ($rootScope.me.id !== $scope.node.id) {
                    $socket.emit('join:user', [$scope.node.id]);
                }

                $socket.on('post:create', function (message) {
                    if (
                        $scope.posts
                            .map(function (item) {
                                return Number(item.id);
                            })
                            .indexOf(Number(message.node.id)) === -1
                    ) {
                        if (message.place.name === 'user' && Number(message.place.id) === Number($scope.node.id)) {
                            $socket.emit('join:post', [message.node.id]);

                            if ($rootScope.me && message.node.owner.id === $rootScope.me.id) {
                                $scope.posts.unshift(message.node);

                                if (!$scope.$$phase) $scope.$digest();
                            } else {
                                $updates.appendUpdate(message.node);
                            }
                        }
                    }
                });
            }

            $scope.$on('$historyBack', $filter.init);

            $scope.showUpdates = function () {
                return $updates.updatesQueue.length > 0;
            };

            $scope.cleanUpdates = function () {
                var updatesQueue = $updates.cleanUpdates();
                var defaultNodes = $scope.posts;
                $scope.posts = updatesQueue.concat(defaultNodes);
            };
        },
    ])
    .controller('user-suggestions-controller', [
        '$rootScope',
        '$scope',
        'graph-user-factory',
        '$flex',
        'WebSocket',
        'RequestManagerFactory',
        function ($rootScope, $scope, userFactory, $flex, $socket, $requestProvider) {
            $requestProvider = $requestProvider.Init('me', 'user', $scope);

            function shuffleArray(array) {
                return array
                    .map(function (a) {
                        return [Math.random(), a];
                    })
                    .sort(function (a, b) {
                        return a[0] - b[0];
                    })
                    .map(function (a) {
                        return a[1];
                    });
            }

            $scope.suggestions = [];
            $scope.pendingResponse = false;
            $scope.isSuggestionHidden = sessionStorage.getItem('isSuggestionHidden') === 'true';

            $scope.limitByScreen = 4;
            $scope.suggestionsOffsetLeft = 1;
            $scope.suggestionsOffsetRight = 1;

            userFactory.querySuggestions('me').then(function (response) {
                if (response.data.state === 0) {
                    $scope.suggestions = shuffleArray(response.data.data);
                    $scope.suggestionsOffsetRight = $scope.suggestions.length - ($scope.limitByScreen - 1);
                }
            });

            $scope.hideSuggestion = function (suggestionId) {
                if (!$scope.pendingResponse) {
                    $scope.pendingResponse = true;

                    userFactory.hideSuggestion('me', suggestionId).then(function (response) {
                        if (response.data.state === 0) {
                            $scope.suggestions.forEach(function (suggestion, index) {
                                if (suggestion.id === suggestionId) {
                                    $scope.suggestions.splice(index, 1);
                                }
                            });

                            $scope.pendingResponse = false;
                        }
                    });
                }
            };

            $scope.addFriend = function (suggestionId) {
                $scope.pendingResponse = true;

                $requestProvider.Create(suggestionId, 'user', 'x', function (response) {
                    // if (response.data.state === 0) {
                    $scope.suggestions.forEach(function (suggestion, index) {
                        if (suggestion.id === suggestionId) {
                            $scope.suggestions.splice(index, 1);
                        }
                    });

                    $scope.pendingResponse = false;
                    // }
                });
            };

            $socket.on('me:suggestion:hide', function (data) {
                var suggestionId = parseInt(data.node.entry_id);

                $scope.suggestions.forEach(function (suggestion, index) {
                    if (suggestion.id === suggestionId) {
                        $scope.suggestions.splice(index, 1);
                        if (!$scope.$$phase) $scope.$digest();
                    }
                });
            });

            $socket.on('me:request:create', function (data) {
                var suggestionId = data.place.id;
                console.log(suggestionId);
                $scope.suggestions.forEach(function (suggestion, index) {
                    if (suggestion.id === suggestionId) {
                        $scope.suggestions.splice(index, 1);
                        if (!$scope.$$phase) $scope.$digest();
                    }
                });
            });

            $scope.hideBlock = function () {
                sessionStorage.setItem('isSuggestionHidden', true);
                $scope.isSuggestionHidden = true;
            };
        },
    ]);

/**
 * @typedef PaginateOptions
 * @property {number} page Initial page
 * @property {Object} queryFilters Query string parameters to apply to the request
 */

/**
 * @typedef PaginateData
 * @property {Array} items - Items returned by page query
 * @property {number} totalPages - Number of total pages taken from server response
 */

/**
 * @todo Extract it to it's own Angular factory
 * @param {Function} loadPageFn Functions that will load a given page and return a Promise with required data.
 * @param {PaginateOptions} options
 * @constructor
 */
function Paginate(loadPageFn, options) {
    var self = this;

    var _queryFilters = {};

    /**
     * Should load page data and return a Promise
     * @type {Function}
     */
    self.loadPageFn = loadPageFn;

    /**
     * Called when loadPageFn resolves successfully.
     * You can overwrite this function and treat it as a listener.
     * @param {PaginateData} paginationData
     */
    self.onPageLoad = function (paginationData) {};

    /**
     * Called when pagination is `.reset()`
     * You can overwrite this function and treat it as a listener.
     */
    self.onReset = function () {};

    self.currentPage = 1;

    /**
     * Total number of pages. It will be set on initial data load based on data returned from server.
     * @type {number}
     */
    self.totalPages = 0;

    // Initialize pagination by loading first page of data
    self.reset = reset;
    self.reset(options);

    /**
     * Loads the next page of data.
     */
    self.nextPage = function () {
        loadPage(++self.currentPage);
    };

    /**
     * Reset (or initialize) the pagination.
     * @param {PaginateOptions} options
     */
    function reset(options) {
        self.onReset();

        options = options || {};

        self.currentPage = options.page || 1;
        _queryFilters = options.queryFilters || {};

        loadPage(self.currentPage);
    }

    /**
     * Loads a given page. Respects query filters.
     * @param {number} page Page number
     */
    function loadPage(page) {
        var queryParams = angular.extend({}, { page: page }, _queryFilters);
        self.loadPageFn(queryParams).then(onLoadSuccess);
    }

    /**
     * @param {PaginateData} paginationData
     * @returns {PaginateData}
     */
    function onLoadSuccess(paginationData) {
        // this callback has access to returned items
        self.onPageLoad(paginationData);
        // we now know total pages
        self.totalPages = paginationData.totalPages;
        return paginationData;
    }
}
